import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import { API, RISKMGT } from '@const'
import * as utils from '@utils'
import { Grid, Select, MenuItem, FormControl, InputLabel, Button } from '@material-ui/core'
import { TextField } from '@prototype'
import PfSubPfSelect from '@select/pf-sub-pf-select'
import Table from '@tables/table'
import ConfirmMsgDialog from '@msg/confirm-msg-dialog'
import { EditRiskInfoDialog, EditRiskRuleBigRichCompDialog, EditRiskRuleHoneymoonDialog } from '@risk'
const COMPONENT_GROUP = 'default_rtp_setting'

class RiskRuleSettingPage extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key) => {
            return utils.t(key, 'RiskRuleSettingPage')
        }
    }

    columnsTemplate = {
        [RISKMGT.RISK_LABEL_BIG_RICH_COMPENSATION]: [
            {
                field: 'pf_sub_pf_id',
                type: 'platform',
            },
            {
                field: 'oid',
            },
            {
                field: 'game_code',
            },
            {
                field: 'game_name',
                translate: {
                    dataKey: 'game_code',
                    tranKey: 'GameName',
                },
            },
            {
                field: 'rtp_level',
            }
        ],
        [RISKMGT.RISK_LABEL_BLACKLIST]: [
            {
                field: 'pf_sub_pf_id',
                type: 'platform',
            },
            {
                field: 'oid',
            },
            {
                field: 'game_code',
            },
            {
                field: 'game_name',
                translate: {
                    dataKey: 'game_code',
                    tranKey: 'GameName',
                },
            },
            {
                field: 'rtp_level',
            },
            {
                field: 'ban_multiple',
                render: (rowData) => {
                    if (rowData.ban_multiple === -1) return this.t('unset')
                    return rowData.ban_multiple
                },
            }
        ],
        [RISKMGT.RISK_LABEL_HONEYMOON_1]: [
            {
                field: 'pf_sub_pf_id',
                type: 'platform',
            },
            {
                field: 'oid',
            },
            {
                field: 'game_code',
            },
            {
                field: 'game_name',
                translate: {
                    dataKey: 'game_code',
                    tranKey: 'GameName',
                },
            },
            {
                field: 'honeymoon_1_rtp_level',
                render: (rowData) => rowData['rtp_level'],
            },
            {
                field: 'honeymoon_2_rtp_level',
                render: (rowData) => {
                    const honeymoon2 = this.state.gameRiskInfo[
                        utils.ComposeGameRiskInfoKey(rowData.oid, RISKMGT.RISK_LABEL_HONEYMOON_2, rowData.pf_sub_pf_id)
                    ]
                    return honeymoon2 ? honeymoon2.rtp_level : ''
                },
            },
        ],
    }

    state = {
        compDidMount: false,
        risk_label: RISKMGT.RISK_LABEL_BIG_RICH_COMPENSATION,
        gameRiskInfo: {},
        riskRuleLsit: {},
        columns: [],
    }

    componentDidMount() {
        if (utils.checkValid(COMPONENT_GROUP + '.edit')) {
            this.columnsTemplate[this.state.risk_label].push({
                field: 'edit_rtp',
                hideTitle: true,
                render: (rowData) => {
                    return (
                        <Button
                            variant="contained"
                            style={{ minWidth: '72px' }}
                            onClick={() => {
                                this.editRiskInfoDialog.OpenDialog(rowData, this.state.gameRiskInfo)
                            }}
                            color="primary">
                            {this.t('setting')}
                        </Button>
                    )
                },
            })
        }

        this.setState({
            compDidMount: true,
            columns: this.columnsTemplate[this.state.risk_label],
        })
    }

    getValue(risk_label, key, idx) {
        if (!this.pfSelect) return
        const rule = this.state.riskRuleLsit[utils.ComposeRiskRuleKey(risk_label, this.pfSelect.state.pfSubPfId)]
        return rule ? (idx !== undefined ? rule[key][idx] : rule[key]) : ''
    }

    queryRiskRule(callback, failCallback) {
        const risk_label_list = [this.state.risk_label]
        if (this.state.risk_label === RISKMGT.RISK_LABEL_BIG_RICH_COMPENSATION) {
            risk_label_list.push(RISKMGT.RISK_LABEL_BIG_RICH_COMPENSATION_CANCEL)
        } else if (this.state.risk_label === RISKMGT.RISK_LABEL_HONEYMOON_1) {
            risk_label_list.push(RISKMGT.RISK_LABEL_HONEYMOON_2)
        }

        utils.apiRequest(
            'get',
            API.RISKMGT_RISK_RULE_LIST,
            {
                risk_label_list: risk_label_list.join(),
                pf_sub_pf_id: this.pfSelect.state.pfSubPfId,
            },
            (data) => {
                if (data)
                    this.setState(
                        {
                            riskRuleLsit: data,
                        },
                        callback
                    )
            },
            () => {
                failCallback()
            },
            true
        )
    }

    queryData = () => {
        this.table.SetLoading(true)
        this.queryRiskRule(
            () => {
                const riskLabelList = [this.state.risk_label]
                if (this.state.risk_label === RISKMGT.RISK_LABEL_HONEYMOON_1) {
                    riskLabelList.push(RISKMGT.RISK_LABEL_HONEYMOON_2)
                }

                utils.apiRequest(
                    'get',
                    API.RISKMGT_GAME_RISK_INFO_LIST,
                    {
                        risk_label_list: riskLabelList.join(),
                        pf_sub_pf_id: this.pfSelect.state.pfSubPfId,
                    },
                    (data) => {
                        const tempList = []
                        for (const idx in data) {
                            if (data[idx].risk_label !== this.state.risk_label) {
                                continue
                            }

                            tempList.push(data[idx])
                        }

                        this.table.SetData(tempList)
                        this.setState({ gameRiskInfo: data })
                    },
                    (_err) => {
                        this.table.SetData([])
                    },
                    true
                )
            },
            () => {
                this.table.SetData([])
            }
        )
    }

    render() {
        return (
            <Grid container spacing={2}>
                <Grid item xs={5}>
                    <PfSubPfSelect
                        onRef={(ref) => (this.pfSelect = ref)}
                        options={{
                            hideAllSubPlatform: true,
                            subPfChangeCallback: () => {
                                this.queryData()
                            },
                            hideCurrency: true,
                        }}></PfSubPfSelect>
                    <FormControl className={this.props.classes.formControl}>
                        <InputLabel htmlFor="age-simple">{this.t('riskLabel')}</InputLabel>
                        <Select
                            value={this.state.risk_label}
                            onChange={(event) => {
                                this.setState(
                                    {
                                        risk_label: event.target.value,
                                    },
                                    () => this.queryData()
                                )
                            }}>
                            <MenuItem value={RISKMGT.RISK_LABEL_BIG_RICH_COMPENSATION}>{this.t(RISKMGT.RISK_LABEL_BIG_RICH_COMPENSATION)}</MenuItem>
                            <MenuItem value={RISKMGT.RISK_LABEL_BLACKLIST}>{this.t(RISKMGT.RISK_LABEL_BLACKLIST)}</MenuItem>
                            <MenuItem value={RISKMGT.RISK_LABEL_HONEYMOON_1}>{this.t(RISKMGT.RISK_LABEL_HONEYMOON_1)}</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>
                {Object.keys(this.state.riskRuleLsit).length && <Grid item xs={7}>
                    {this.state.risk_label === RISKMGT.RISK_LABEL_HONEYMOON_1 && (
                        <React.Fragment>
                            {this.t('enableHoneymoon')}
                            <TextField
                                className={this.props.classes.textField}
                                readOnly
                                label={this.t('honeymoon1RoundBelow')}
                                value={this.getValue(RISKMGT.RISK_LABEL_HONEYMOON_1, 'round_boundary', 1)}
                            />
                            <TextField
                                className={this.props.classes.textField}
                                readOnly
                                label={this.t('honeymoon2RoundBelow')}
                                value={this.getValue(RISKMGT.RISK_LABEL_HONEYMOON_2, 'round_boundary', 1)}
                            />
                            <Button
                                variant="contained"
                                onClick={() => {
                                    this.editRiskRuleHoneymoonDialog.OpenDialog(this.pfSelect.state.pfSubPfId, this.state.riskRuleLsit)
                                }}
                                color="primary">
                                {this.t('honeymoonSetting')}
                            </Button>
                        </React.Fragment>
                    )}
                    {this.state.risk_label === RISKMGT.RISK_LABEL_BIG_RICH_COMPENSATION && (
                        <React.Fragment>
                            <Grid item xs={12}>
                                {this.t('enableBigRichCompensation')}
                                <TextField
                                    className={this.props.classes.textField}
                                    readOnly
                                    label={this.t('accumulatedDays')}
                                    value={this.getValue(RISKMGT.RISK_LABEL_BIG_RICH_COMPENSATION, 'accumulated_days') || 0}
                                />
                                <TextField
                                    className={this.props.classes.textField}
                                    readOnly
                                    label={this.t('roundAbove')}
                                    value={this.getValue(RISKMGT.RISK_LABEL_BIG_RICH_COMPENSATION, 'round_boundary', 0) || 0}
                                />
                                <TextField
                                    className={this.props.classes.textField}
                                    readOnly
                                    label={this.t('rtpBelow')}
                                    value={`${this.getValue(RISKMGT.RISK_LABEL_BIG_RICH_COMPENSATION, 'rtp_boundary', 1) || 0}%`}
                                />
                                <TextField
                                    className={this.props.classes.textField}
                                    readOnly
                                    label={this.t('lossPrizeAbove')}
                                    value={-this.getValue(RISKMGT.RISK_LABEL_BIG_RICH_COMPENSATION, 'prize_boundary', 1) || 0}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                {this.t('disableBigRichCompensation')}
                                <TextField
                                    className={this.props.classes.textField}
                                    readOnly
                                    label={this.t('accumulatedDays')}
                                    value={this.getValue(RISKMGT.RISK_LABEL_BIG_RICH_COMPENSATION_CANCEL, 'accumulated_days') || 0}
                                />
                                <TextField
                                    className={this.props.classes.textField}
                                    readOnly
                                    label={this.t('rtpAbove')}
                                    value={`${this.getValue(RISKMGT.RISK_LABEL_BIG_RICH_COMPENSATION_CANCEL, 'rtp_boundary', 0) || 0}%`}
                                />
                                <Button
                                    variant="contained"
                                    onClick={() => {
                                        this.editRiskRuleBigRichCompDialog.OpenDialog(this.pfSelect.state.pfSubPfId, this.state.riskRuleLsit)
                                    }}
                                    color="primary">
                                    {this.t('bigRichCompensationSetting')}
                                </Button>
                            </Grid>
                        </React.Fragment>
                    )}
                </Grid>}
                <Grid item xs={12}>
                    {this.state.compDidMount && (
                        <Table
                            ownerName="RiskRuleSettingPage"
                            columns={this.state.columns}
                            options={{
                                orderIdx: 1,
                            }}
                            onRef={(ref) => (this.table = ref)}
                        />
                    )}
                    <ConfirmMsgDialog onRef={(ref) => (this.confirmDialog = ref)} />
                    <EditRiskInfoDialog
                        confirmCallback={() => {
                            this.queryData()
                        }}
                        onRef={(ref) => (this.editRiskInfoDialog = ref)}
                    />
                </Grid>
                <EditRiskRuleHoneymoonDialog
                    onRef={(ref) => (this.editRiskRuleHoneymoonDialog = ref)}
                    confirmCallback={() => {
                        this.queryData()
                    }}></EditRiskRuleHoneymoonDialog>
                <EditRiskRuleBigRichCompDialog
                    onRef={(ref) => (this.editRiskRuleBigRichCompDialog = ref)}
                    confirmCallback={() => {
                        this.queryData()
                    }}></EditRiskRuleBigRichCompDialog>
            </Grid>
        )
    }
}

const styles = (theme) => {
    return {
        formControl: {
            margin: theme.spacing(1),
            width: '172px',
        },
        textField: {
            margin: theme.spacing(1),
            width: '150px',
        },
    }
}

RiskRuleSettingPage.propTypes = {
    classes: PropTypes.object.isRequired,
    dataService: PropTypes.object,
    onRef: PropTypes.func,
}

export default hoc(styles)(RiskRuleSettingPage)
